import { organizationApi, useLazyCurrentOrganizationPreviewQuery } from '@entities/organization/api/organization-api';
import { OrganizationPreviewDataRequest } from '@entities/organization/api/organization-types';
import { useSharedQueryTriggerStatus } from '@shared/lib/hooks/use-shared-query-trigger-status/use-shared-query-trigger-status';
import { useDispatch } from 'react-redux';

/* 
    Позволяет шарить результат useLazyQuery между разными компонентами, использующими useSharedQuery
    При обновлении  результата useLazyQuery происходит обновление всех зависимых компонентов
*/
export const useCurrentOrganizationPreviewSharedQuery = (parameters: OrganizationPreviewDataRequest) => {
    const dispatch = useDispatch();
    const { setTriggerStatus } = useSharedQueryTriggerStatus();
    const [queryTrigger] = useLazyCurrentOrganizationPreviewQuery();
    const queryResult = organizationApi.endpoints.currentOrganizationPreview.useQueryState(parameters);

    const handleReset = () => {
        dispatch(organizationApi.util.invalidateTags(['CurrentOrganization', 'OrganizationsList']));
    };

    const handleTrigger = async (args: OrganizationPreviewDataRequest) => {
        setTriggerStatus('pending');
        const result = await queryTrigger(args, true);
        setTriggerStatus('completed');
        return result;
    };

    return [handleTrigger, queryResult, handleReset] as const;
};
